import { render, staticRenderFns } from "./AffectedProtein.vue?vue&type=template&id=1b10494a&scoped=true"
import script from "./AffectedProtein.vue?vue&type=script&lang=js"
export * from "./AffectedProtein.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=1b10494a&prod&scoped=true&lang=css&external"
import style1 from "./AffectedProtein.vue?vue&type=style&index=1&id=1b10494a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b10494a",
  null
  
)

export default component.exports